import axios from "axios";

const API_PREFIX = "/api";

const client = axios.create({
  // baseURL: "https://api.xiaoxing.asia",
  baseURL: "https://www.fcai168.xyz",
  withCredentials: true,
  timeout: 15000,
  headers: {
    "Content-Type": "application/json"
  }
});

client.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access-ui.token");
    if (token) {
      config.headers = config.headers || {};
      if (!config.headers.Authorization) {
        config.headers.Authorization = `${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export async function listKeys(params) {
  const res = await client.get(`${API_PREFIX}/access-keys`, { params });
  return res.data;
}

export async function getKey(id) {
  const res = await client.get(`${API_PREFIX}/access-keys/${id}`);
  return res.data;
}

export async function createKey(payload) {
  const res = await client.post(`${API_PREFIX}/access-keys`, payload);
  return res.data;
}

export async function updateKey(id, payload) {
  const res = await client.post(`${API_PREFIX}/access-keys/${id}`, payload);
  return res.data;
}

export async function deleteKey(id) {
  const res = await client.post(`${API_PREFIX}/access-keys/${id}/delete`);
  return res.data;
}

export async function listLogs(params) {
  const res = await client.get(`${API_PREFIX}/access-logs`, { params });
  return res.data;
}

export async function listUsers(params) {
  const res = await client.get(`${API_PREFIX}/users`, { params });
  return res.data;
}

export async function createUser(payload) {
  const res = await client.post(`${API_PREFIX}/users`, payload);
  return res.data;
}

export async function updateUser(id, payload) {
  const res = await client.post(`${API_PREFIX}/users/${id}`, payload);
  return res.data;
}

export async function deleteUser(id) {
  const res = await client.post(`${API_PREFIX}/users/${id}/delete`);
  return res.data;
}

export async function listKeyUsers(accessKeyId) {
  const res = await client.get(`${API_PREFIX}/access-keys/${accessKeyId}/users`);
  return res.data;
}

export async function listChases(params) {
  const res = await client.get(`${API_PREFIX}/chases`, { params });
  return res.data;
}

export async function createChase(payload) {
  const res = await client.post(`${API_PREFIX}/chases`, payload);
  return res.data;
}

export async function updateChase(id, payload) {
  const res = await client.post(`${API_PREFIX}/chases/${id}`, payload);
  return res.data;
}

export async function deleteChase(id) {
  const res = await client.post(`${API_PREFIX}/chases/${id}/delete`);
  return res.data;
}

export async function getChaseOdds(content) {
  const res = await client.get(`${API_PREFIX}/chases/odds`, { params: { content } });
  return res.data;
}

export async function listChaseUsers(params) {
  const res = await client.get(`${API_PREFIX}/chase-users`, { params });
  return res.data;
}

export async function createChaseUser(payload) {
  const res = await client.post(`${API_PREFIX}/chase-users`, payload);
  return res.data;
}

export async function updateChaseUser(id, payload) {
  const res = await client.post(`${API_PREFIX}/chase-users/${id}`, payload);
  return res.data;
}
export async function updateChaseUserReset(id, payload) {
  const res = await client.post(`${API_PREFIX}/chase-users/${id}/reset`, payload);
  return res.data;
}

export async function deleteChaseUser(id) {
  const res = await client.post(`${API_PREFIX}/chase-users/${id}/delete`);
  return res.data;
}

export async function batchStartChaseUsers(ids) {
  const res = await client.post(`${API_PREFIX}/chase-users/batch-start`, { ids });
  return res.data;
}

export async function batchPauseChaseUsers(ids) {
  const res = await client.post(`${API_PREFIX}/chase-users/batch-pause`, { ids });
  return res.data;
}

export async function calculatorCompute(params) {
  const res = await client.get(`${API_PREFIX}/calculator`, { params });
  return res.data;
}

export async function getOmissionSummary(params) {
  const res = await client.get(`${API_PREFIX}/omission`, { params });
  return res.data;
}

export async function listCards() {
  const res = await client.get(`${API_PREFIX}/cards`);
  return res.data;
}

export async function listLottery(params) {
  const res = await client.get(`${API_PREFIX}/lottery`, { params });
  return res.data;
}

export { client };
